import { atom } from 'jotai';

export interface CoreEntityMissingDialog {
  open: boolean;
  title: string;
  message: string;
  contextUrl?: string;
}

export const coreEntityMissingDialogAtom = atom<CoreEntityMissingDialog>({
  open: false,
  title: '',
  message: '',
});
